import * as React from 'react';

export const EditFormContext = React.createContext();
